import { TextField } from "components";
import { useFormContext } from "react-hook-form";

export enum AccountInformationFormEnum {
  FirstName = "firstName",
  LastName = "lastName",
  Email = "email",
}

const AccountInformationStep = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <div className="space-y-4">
      <TextField
        errors={errors}
        isRequired
        label="First Name"
        placeholder="First Name"
        {...register(AccountInformationFormEnum.FirstName)}
      />
      <TextField
        errors={errors}
        isRequired
        label="Last Name"
        placeholder="Last Name"
        {...register(AccountInformationFormEnum.LastName)}
      />
      <TextField
        errors={errors}
        isRequired
        label="E-mail address"
        placeholder="E-mail address"
        {...register(AccountInformationFormEnum.Email)}
      />
    </div>
  );
};

export default AccountInformationStep;
